import { useAppSelector } from "app/redux-store-interactions";
import { selectIsProcoreMobileDesign } from "slices/explorer";
import { hasMouseSupport } from "utils/misc";

/**
 * Returns true if mobile interaction style (with D pads) should be used for measure interactions.
 * Currently it should only happen on Procore Mobile Design when there's no mouse support (on mobile device or on emulator).
 * TODO enable on standalone app as well when mobile interactions are more stable.
 */
export function useIsMobileMeasureInteraction() {
    const isProcoreMobileDesign = useAppSelector(selectIsProcoreMobileDesign);
    const hasMouse = hasMouseSupport();
    return isProcoreMobileDesign && !hasMouse;
}
